import { takeLatest } from 'redux-saga/effects';

import * as mfaActions from '../actions';
import { verifyMFACodeSaga } from './verify';

/**
 * The root `mfa` saga.
 *
 * @method mfaSaga
 * @type   {Generator}
 */
function* mfaSaga() {
    // Verify the MFA code for the current MFA session.
    yield takeLatest(mfaActions.verifyMFACode.TRIGGER, verifyMFACodeSaga);
}

// Default export is the module's root saga.
export default mfaSaga;

// Named exports are all the internal sagas that can be used
// for testing as well as imports in other modules
export { startMFAFlowSaga } from './flow';
export { verifyMFACodeSaga };
